import {TaskTypeActionRequired, TaskTypeReplyButtons} from "../../gd/task-type/task-type"

export default class TaskTypeSettings {

    public actionRequired               : TaskTypeActionRequired
    public isGeneric                    : boolean       = false
    public requiredFields               : string[]
    public hiddenFields                 : string[]      // this are disabled SystemFields
    public checklist                    : any
    public restrictedReplyButton?       : TaskTypeReplyButtons      // pizdec ,,, kto eto pridumal ? pizdec undefined pochemu ... pochemu restricted vmesto true false... uzas ....
    public showStatusUpdateButton       : boolean
    public showCreateReminderButton     : boolean

    constructor(settingsData: any) {
        this.actionRequired          = (!settingsData ||
            ![
                TaskTypeActionRequired.ALLOWED,
                TaskTypeActionRequired.DENIED_ON_REPLY
            ].includes(settingsData.actionRequired)) ?
            TaskTypeActionRequired.ALLOWED
            :
            settingsData.actionRequired

        this.isGeneric                  = _.get(settingsData,'isGeneric',false)
        this.requiredFields             = _.get(settingsData,'requiredFields',[])
        this.hiddenFields               = _.get(settingsData,'hiddenFields',[])
        this.checklist                  = _.get(settingsData,'checklist',null)
        this.restrictedReplyButton      = _.get(settingsData,'restrictedReplyButton',undefined)
        this.showStatusUpdateButton     = _.get(settingsData,'showStatusUpdateButton',true)
        this.showCreateReminderButton   = _.get(settingsData,'showCreateReminderButton',true)
    }

    checkSystemFieldDisabled(fieldId:string) {
        return this.hiddenFields.includes(fieldId)
    }

    get isActionRequiredEnabled() {
        return !this.checkSystemFieldDisabled('actionRequiredUserId')
    }

    toJSON() {
        return {
            actionRequired              : this.actionRequired,
            isGeneric                   : this.isGeneric,
            requiredFields              : this.requiredFields,
            hiddenFields                : this.hiddenFields,
            checklist                   : this.checklist,
            restrictedReplyButton       : this.restrictedReplyButton,
            showStatusUpdateButton      : this.showStatusUpdateButton,
            showCreateReminderButton    : this.showCreateReminderButton,
        }
    }
}